import { loanHasApplicationTestTag, loanHasTestTag } from './loan-helper';
import { CookieHelper } from './cookie-helper';

const UrlHelper = {
  removeR: (history) => {
    const newHistory = history;
    newHistory.location.pathname = history.location.pathname.replace('/r/', '/');
    return newHistory;
  },

  getAllRoutes: (routeObj) => Object.keys(routeObj).map((key) => routeObj[key]),

  getQueryParam: (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
    return false;
  },

  getPathName: () => window.location.pathname,

  decorateURLParamsWithTest: (loan, urlParams, key, tag, paramName) => {
    const hasTestLabel = loanHasApplicationTestTag(key, tag, loan);

    if (hasTestLabel) {
      if (!urlParams.includes(paramName)) {
        const concatanator = urlParams !== undefined && urlParams !== null && urlParams !== '' ? '&' : '?';
        urlParams += `${concatanator}${paramName}=${hasTestLabel}`;
      }
    }
    return urlParams;
  },

  decorateURLParamsWithApplicationTest: (loan, urlParams, testKey, test, paramName) => {
    const hasTestLabel = loanHasApplicationTestTag(testKey, test, loan);

    if (hasTestLabel) {
      if (!urlParams.includes(paramName)) {
        const concatenator = urlParams ? '&' : '?';
        urlParams += `${concatenator}${paramName}=${hasTestLabel}`;
      }
    }
    return urlParams;
  },

  getEnvironment: () => {
    if (window?.location?.host?.includes('localhost')) {
      return 'localhost';
    }

    if (window?.location?.host?.includes('dev.supersim.com.br')) {
      return 'development';
    }

    if (window?.location?.host?.includes('www.supersim.com.br')) {
      return 'production';
    }
  },

  checkIfUrlParamsIsBase64: (param) => {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(Number(param))) return param;
    try {
      return window.atob(param);
    } catch (err) {
      return param;
    }
  },

  getUtmParams: () => {
    // Get page url
    const url = window.location.href;

    // Create url with the string return in const url
    const urlObj = new URL(url);

    // Get sourcer and referer values in cookie
    const originalSourceCookie = (!/^https?:\/\//i.test(CookieHelper.getUrl('X-Supersim-Request-Original-Source')) ? "https://" : "") + CookieHelper.getUrl('X-Supersim-Request-Original-Source');
    const originalReferrerCookie = CookieHelper.getUrl('X-Supersim-Request-Original-Referrer');

    // Create url with source cookie value
    const urlOriginalSourceCookie = new URL(originalSourceCookie);

    // Define utm source value
    const utmSource = 
      (urlObj.searchParams.get("utm_source") ? urlObj.searchParams.get("utm_source") : 
      document.referrer === '' ? "direct" :
      urlOriginalSourceCookie.searchParams.get("utm_source") ? urlOriginalSourceCookie.searchParams.get("utm_source") : 
      originalReferrerCookie) || "";

    // Define utm campaign value
    const utmCampaign = 
      urlObj.searchParams.get("utm_campaign") ? urlObj.searchParams.get("utm_campaign") :
      urlOriginalSourceCookie.searchParams.get("utm_campaign") ? urlOriginalSourceCookie.searchParams.get("utm_campaign") : 
      "";

    // Define utm medium value
    const utmMedium = 
      urlObj.searchParams.get("utm_medium") ? urlObj.searchParams.get("utm_medium") :
      urlOriginalSourceCookie.searchParams.get("utm_medium") ? urlOriginalSourceCookie.searchParams.get("utm_medium") : 
      "";

    // Define utm_content
    const utmContent = 
      urlObj.searchParams.get("utm_content") ? urlObj.searchParams.get("utm_content") :
      urlOriginalSourceCookie.searchParams.get("utm_content") ? urlOriginalSourceCookie.searchParams.get("utm_content") : 
    "";

    // Return utm values
    return { utmSource, utmCampaign, utmMedium, utmContent }
  },

  buildUrlParamsWithUtms: (source, campaign, medium, content) => {
    let urlParams = "";

    if (source) {
      urlParams += `utm_source=${source}&`;
    }

    if (campaign) {
        urlParams += `utm_campaign=${campaign}&`;
    }

    if (medium) {
        urlParams += `utm_medium=${medium}&`;
    }

    if (content) {
      urlParams += `utm_content=${content}&`;
    }

    if (urlParams.endsWith("&")) {
      urlParams = urlParams.slice(0, -1);
    }

    return urlParams;
  },
};

export default UrlHelper;
